import LoginForm from "./LoginForm";
import login_bg from "assets/login_bg.png";
import sdaia_logo from "assets/sdaia_logo.png";
import ProcessHubLogo from "components/shared/ProgressMonitoringLogo";

const Authorization = () => {
  return (
    <div
      className="w-screen h-screen flex items-center justify-center bg-cover bg-center relative"
      style={{ backgroundImage: `url(${login_bg})` }}
    >
      <div className="absolute bottom-10 left-10 right-10 flex justify-between">
        <img src={sdaia_logo} />
        <ProcessHubLogo variant="regular" />
      </div>
      <LoginForm />
    </div>
  );
};

export default Authorization;
